// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appVersion: 'v0.0.1',
  USERDATA_KEY: 'authf649fc9a5f55',
  isMockEnabled: false,
  apiUrl: 'https://api.maritimecloud.ai',
  apiSemarURL: 'https://semar.maritimecloud.ai',
  apiSemarApiURL: 'https://semarapi.maritimecloud.ai',
  apiCrewUrl: 'https://crewapi.maritimecloud.ai/api',
  apiCCTVUrl: 'https://ionscctv.maritimecloud.ai/api',
  webDMUrl: 'https://dm.maritimecloud.ai',
  webCrewUrl: 'https://crew.maritimecloud.ai',
  webPMS: 'https://pms.maritimecloud.ai',
  staticMediaUrl: 'https://static.maritimecloud.ai/content_file_upload',
  appThemeName: 'MCP',
  turnstile: {
    siteKey: '0x4AAAAAAA8XD08Qe8cLS-vP',
  },
  enc_xml: {
    apiUrl: 'https://xmaps.id/geoserver/seaxmaps/wms?service=WMS&request=GetMap&layers=seaxmaps:seaxmaps_style_01&format=image/png&transparent=true&version=1.1.0&width=256&height=256&srs=EPSG:3857'
  },
  enc: {
    apiUrl: 'https://gis.charttools.noaa.gov/arcgis/rest/services/MCS/ENCOnline/MapServer/exts/MaritimeChartService/WMSServer?service=WMS&request=GetMap&format=image/png&srs=EPSG:3857&width=256&height=256'
  },
  weatherOpenportguide: {
    apiUrl: 'https://weather.openportguide.de',
  },
  maptiler: {
    // apiKey: 'X6joOBrI9dkVrLRQaFKM',
    apiKey: 'kOuifsIHt7iKcA0aklGS',
    style: 'https://api.maptiler.com/maps/8e5bef56-dd77-42e7-9907-20d4accf66a1/style.json?key=kOuifsIHt7iKcA0aklGS'
  },
  nextcloud: {
    apiUrl: 'https://nextcloud.besok.org/sso',
  },
  mapbox: {
    accessToken: 'pk.eyJ1IjoiY29uZmlyZSIsImEiOiJjbG42ZDYwZDkwOTUyMnJtaGd2djRscTJ2In0.w-kR0l4cjCv-pNkXspqB0Q'
  },
  weatherlayers: {
    accessToken: 'AXRyKvzaq44RhUUEfATB',
    catalogUrl: 'https://catalog.weatherlayers.com/catalog/search',
    version: '2024.7.0',
    collections: {
      wind: 'gfs/wind_10m_above_ground'
    }
  },
  openweathermap: {
    apiUrl: 'https://api.openweathermap.org/data/2.5/weather',
    appid: '94027623d0b9bdf60bed7718d7eb1833',
    iconUrl: 'https://openweathermap.org/img/w'
  },
  firebase: {
    apiKey: "AIzaSyCHpn-JJFZSDhZhULTIrebMF-2i6g4ftvE",
    authDomain: "bsk-mcp.firebaseapp.com",
    projectId: "bsk-mcp",
    storageBucket: "bsk-mcp.firebasestorage.app",
    messagingSenderId: "874525469513",
    appId: "1:874525469513:web:a1503dd1030c2b792b0898",
    vapidKey: "BLbDZzKFW6bLvsqzuZKTQfHQDrP1YNla6p2JUClllv1HssFsyQDb3LBzq3UcZTcvLl5rVa273Bc0Rja3oPOjacs"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
